/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

import { USER_FRAGMENT } from '@/graphql/fragments'

export const CHECK_PHONE_NUMBER_VERIFICATION_CODE = gql`
  ${USER_FRAGMENT}
  mutation CheckPhoneNumberVerificationCode(
    $data: CheckPhoneNumberVerificationCodeInput!
  ) {
    checkPhoneNumberVerificationCode(data: $data) {
      ...User
    }
  }
`
